import styled from 'styled-components';
import { ListItemAsLink } from '@comeon/ui';
import Icon, { ICON_RIGHT } from '../../../icon/index';
import SportsbookSportIcon from './sportsbook-sport-icon';
import React, { ReactElement } from 'react';
import { LinkProps } from 'react-router-dom';

const IconChevron = styled(Icon).attrs({ type: ICON_RIGHT })`
	fill: var(--main-action-icons);
`;

const StyledSportIcon = styled(SportsbookSportIcon)`
	fill: var(--main-icons);
`;

type Props = {
	title: string;
	sportIcon?: string;
	iconElement?: ReactElement<unknown>;
	badgeElement?: React.ReactNode;
	onClick?: React.MouseEventHandler;
	className?: string;
} & LinkProps;

/**
 * Component for a sportsbook list item link. Should be used inside a list:
 * ```tsx
 * <ul>
 *  <SportsbookListItemLink to="/sportsbook/football" title="Football"  />
 *  <SportsbookListItemLink to="/sportsbook/tennis" title="Tennis" />
 * </ul>
 * ```
 *
 * It's a link wrapped in li tag thus you can pass any link props to it.
 */
const SportsbookListItemLink: React.FC<Props> = ({
	title,
	sportIcon,
	iconElement,
	onClick,
	badgeElement,
	className,
	...linkProps
}) => (
	<ListItemAsLink
		className={className}
		title={title}
		iconLeft={iconElement || <StyledSportIcon icon={sportIcon} width="18" height="18" />}
		iconRight={<IconChevron type={ICON_RIGHT} />}
		onClick={onClick}
		badgeElement={badgeElement}
		{...linkProps}
	/>
);

export default SportsbookListItemLink;
